import { camelize } from 'inflected';
import { isPlainObject } from 'lodash-es';
export const camelizeKeys = (object) => {
    if (Array.isArray(object)) {
        return object.map((v) => camelizeKeys(v));
    }
    else {
        if (isPlainObject(object)) {
            const camelized = {};
            Object.keys(object).forEach((key) => {
                camelized[camelize(key, false)] = camelizeKeys(object[key]);
            });
            return camelized;
        }
        else {
            return object;
        }
    }
};
